import React, { useEffect, useState } from 'react'
import { StartVisitSvg } from '../../components/button/start-visit/start-visit-svg'
import { CgArrowLongRight } from 'react-icons/cg'
import { useResize } from '../../hooks'
import { Link } from 'react-router-dom'
import { Text } from '../../components'
import { COLOR, FONT } from '../../assets/'
import { 
  StyledBackground,
  StyledDiv,
  SvgDiv,
  StyledText,
  StyledSubText,
  StyledBorder,
  StyledTextDiv,
  StartVisitDiv,
  StartVisitText,
  TextLogo } from '../../components/splash/splash.styled';


const Splash = () => {
  const isMobile = useResize().isMobile;
  const heightSize = useResize().height;

  const minPercent = .7;

  const [ heightPercent, setHeightPercent ] = useState(1);

  useEffect(() => {

    if(isMobile) {
      setHeightPercent(1)
    } else {
      let percent = heightSize / 900;
      
      if(percent < 1) {
        if(percent < minPercent) percent = .6;
        setHeightPercent(percent);
      } else {
        if(percent !== 1){
          setHeightPercent(1);
        }
      }
    }

     
  }, [isMobile, heightSize]);


  return (
    <StyledBackground >
      <StyledDiv style={{ transform: heightPercent !== 1 && `scale(${heightPercent})`}}>
        <div className="divLogo">
          <TextLogo>Amorim<br />Cork<br />Flooring</TextLogo>
        </div>
        <StyledTextDiv>
          <StyledText>
            <Text
              className="d-inline"
              fontFamily=""
              fontSize={FONT.md3}
              fontSizeMobile={FONT.sm3}
              textId="splash.welcome"
              letterSpacing={'2.8px'}
            />
            { isMobile ? <br /> : null } Amorim Cork Flooring</StyledText>
          <StyledSubText>
            <Text letterSpacing={'1.4px'} fontFamily="Amorim Sans Book" color={COLOR.quaternary} fontSize="23px" textId="splash.subtitle" />
          </StyledSubText>
          <StyledBorder>
            <Text
              className="pl-1 d-inline-block"
              fontSize="18px"
              fontFamily="Amorim Sans Book"
              textId="splash.virtual-tour"
              letterSpacing={'2px'}
            />
          </StyledBorder>
        </StyledTextDiv>
        <StartVisitDiv>
          <Link className="no-style" to="/audio-intro">
            <SvgDiv>
              <StartVisitSvg className="svg-hover"/>
              <StartVisitText>
                <Text
                  className="d-inline-block"
                  fontSize=""
                  fontFamily="Amorim Sans Book"
                  textId="splash.start-visit"
                />
                <CgArrowLongRight className='arrow-right' size='1em'/>
              </StartVisitText>
            </SvgDiv>
          </Link>
        </StartVisitDiv>
      </StyledDiv>
    </StyledBackground>
  );
} 

export default Splash;
